<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-title>Cancelar</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title
        v-if="this.dados == 'OUTROS DOCUMENTOS'"
        class="green lighten-4 primary--text font-weight-bold"
        >Cancelar Documento</v-card-title
      >
      <v-card-title
        v-else
        class="green lighten-4 primary--text font-weight-bold"
        >Cancelar Atestado</v-card-title
      >
      <v-card-text>
        <v-form ref="form">
          <v-textarea
            class="mt-6"
            label="Motivo do Cancelamento"
            placeholder="Informe uma justificativa"
            :rules="[(v) => !!v || 'Justificativa obrigatória']"
            v-model="motivo"
          ></v-textarea>
          <v-btn
            rounded
            color="info"
            @click="confirmarCancelamento()"
            class="mt-4"
            >Confirmar cancelamento</v-btn
          >
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" small @click="dialog = false" rounded
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  props: {
    atestado: Object,
  },
  computed: mapState("atestado", ["atestados", "dados"]),
  data: () => ({
    dialog: false,
    motivo: "",
  }),
  methods: {
    async confirmarCancelamento() {
      if (this.$refs.form.validate()) {
        await axios
          .post(
            `/colaborador/atestados?funcao=CANCELAR&codigo=${this.atestado.codigo}`,
            {
              motivo: this.motivo,
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.atestados.find(
                (atest) => atest.codigo == this.atestado.codigo
              ).status = 9;
              this.dialog = false;
              if (this.dados == "OUTROS DOCUMENTOS")
                this.$toasted.success("Documento cancelado com sucesso!");
              else this.$toasted.success("Atestado cancelado com sucesso!");
              this.motivo = "";
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => this.$toasted.error(e));
      }
    },
  },
  mounted() { 
    this.motivo = "";
  },
};
</script>

<style>
</style>